import { bl_fi_deposit_requisition_hdr_RowClass } from '../../dbschema/bl_fi_deposit_requisition_hdr.model';
import { BaseContainerModel } from '../base-container.model';

export class DepositRequisitionContainerModel extends BaseContainerModel {
  bl_fi_deposit_requisition_hdr: bl_fi_deposit_requisition_hdr_RowClass = new bl_fi_deposit_requisition_hdr_RowClass();
}
